import script from "./PublicationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicationForm.vue?vue&type=script&setup=true&lang=js"

import "./PublicationForm.vue?vue&type=style&index=0&id=35d2309c&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35d2309c"]])

export default __exports__